import { registerPlugin } from '@capacitor/core';
const PushNotifications = registerPlugin('PushNotifications', {});
export * from './definitions';
export { PushNotifications };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@capacitor/push-notifications/dist/esm/index.js
// module id = 103
// module chunks = 1